<div class="tiktok-settings" [formGroup]="form">
  <div class="tiktok-settings__field">
    <label class="tiktok-settings__label">Privacy status</label>
    <icn-dropdown
      class="tiktok-settings__dropdown"
      [class.tiktok-settings__dropdown--invalid]="privacyFieldError"
      [large]="true"
      [allowMultiple]="false"
      [listDown]="true"
      placeholder="Select privacy status"
      [showPlaceholderWhenEmpty]="true"
      [selectedValue]="form.controls.privacyLevel.value"
      (selectedValueChange)="onPrivacyChange($event)"
    >
      <icn-dropdown-item
        *ngFor="let option of privacyOptions"
        [value]="option"
        [title]="option"
        [selectable]="!isPrivacyOptionDisabled(option)"
      ></icn-dropdown-item>
    </icn-dropdown>
    <p *ngIf="privacyFieldError" class="tiktok-settings__field-error">{{ privacyFieldError }}</p>
  </div>

  <div class="tiktok-settings__field">
    <label class="tiktok-settings__label">Interaction ability</label>
    <mat-checkbox
      formControlName="allowComment"
      class="tiktok-settings__checkbox"
      [disableRipple]="true"
    >
      Allow Comment
    </mat-checkbox>
    <mat-checkbox
      formControlName="allowDuet"
      class="tiktok-settings__checkbox"
      [disableRipple]="true"
    >
      Allow Duet
    </mat-checkbox>
    <mat-checkbox
      formControlName="allowStitch"
      class="tiktok-settings__checkbox"
      [disableRipple]="true"
    >
      Allow Stitch
    </mat-checkbox>
  </div>

  <div class="tiktok-settings__field">
    <mat-checkbox
      formControlName="contentDisclosureEnabled"
      class="tiktok-settings__checkbox tiktok-settings__checkbox--strong"
      [disableRipple]="true"
    >
      This content promotes myself, a brand, product, or service
    </mat-checkbox>

    <div *ngIf="shouldShowCommercialOptions" class="tiktok-settings__nested">
      <mat-checkbox
        formControlName="isBrandOrganic"
        class="tiktok-settings__checkbox"
        [disableRipple]="true"
      >
        Your Brand
      </mat-checkbox>
      <mat-checkbox
        formControlName="isBrandContent"
        class="tiktok-settings__checkbox"
        [disableRipple]="true"
      >
        Branded Content
      </mat-checkbox>

      <p
        *ngIf="commercialDisclosureError"
        class="tiktok-settings__field-error"
        [title]="commercialDisclosureError"
      >
        {{ commercialDisclosureError }}
      </p>
      <p *ngIf="shouldShowPromotionalContentMessage" class="tiktok-settings__helper">
        Your photo/video will be labeled as 'Promotional content'
      </p>
      <p *ngIf="shouldShowPaidPartnershipMessage" class="tiktok-settings__helper">
        Your photo/video will be labeled as 'Paid partnership'
      </p>
    </div>
  </div>

  <div class="tiktok-settings__field">
    <mat-checkbox
      formControlName="isAigc"
      class="tiktok-settings__checkbox"
      [disableRipple]="true"
    >
      AI-generated content
    </mat-checkbox>
    <p class="tiktok-settings__helper tiktok-settings__helper--aigc">
      When enabled, TikTok labels the post as creator-marked AI-generated content.
    </p>
  </div>

  <div class="tiktok-settings__actions">
    <button
      type="button"
      class="tiktok-settings__reset"
      [disabled]="readonly"
      (click)="resetSettings()"
    >
      Reset settings
    </button>
  </div>
</div>
